import * as React from 'react';
import { PageProps } from 'gatsby';
import { PageLayout as Layout } from '../components/Layouts/PageLayout/PageLayout';
import { Seo } from '../components/Seo/Seo';

import { PageTitle } from '../components/ui/pageTitle/pageTitle';

import PageContentHandler from '../components/PageContentHandler';
import pageFunData from './data/pageFun.json';
import pageFunPreviewData from './data/pageFunPreview.json';

export const HaveSomeFun: React.FC<PageProps> = ({ location }) => {
  if (!location.hostname) return null;

  const pageData =
    location.hostname === 'gatsby.node.tvg.la' ||
    location.hostname === 'localhost'
      ? pageFunPreviewData[0]
      : pageFunData[0];

  if (!pageData) return null;

  return (
    <Layout className="have-some-fun bg bg-fun">
      <Seo title="Have Some Fun" />
      <PageTitle title="Have Some Fun" />
      <PageContentHandler pageData={pageData} />
    </Layout>
  );
};

/* TODO: Implement simple authentication
export default function Page() {
  return (
    <Router basepath="/have-some-fun">
      <PrivateRoute default component={HaveSomeFun} />
    </Router>
  );
}
*/

export default HaveSomeFun;
